import { getUserFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

export async function fetchDepartmentData({ departmentId }) {
  try {
    const query = {
      fields: ["id", "name", "status", getUserFields("head"), getUserFields("coordinators.coordinator")],
    };
    const response = await getItemFromCollection("departments", departmentId, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}